import { openTimesheetAdjustmentModal } from '../../../State/timesheetAdjustmentModal'

export default (timesheet) => (dispatch) => {

  dispatch(openTimesheetAdjustmentModal({ timesheetId: timesheet.id }))

}
